export default class Browser {
  public static isIE() {
    // [bowser](https://github.com/lancedikson/bowser) is too much for now https://stackoverflow.com/a/9851769/225291
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore - documentMode is only IE
    return /*@cc_on!@*/ false || !!document.DOCUMENT_NODE;
  }
}
